<template>
  <div v-if="linkData">
    <router-link
      :to="linkData.to"
      class="menu-item"
      :event="this.$props.linkData.subItems ? '' : 'click'"
      @click.native="handleClick"
    >
      <div class="icon-container">
        <BIcon :icon="linkData.icon" />
      </div>
      <div class="label">{{ linkData.label }}</div>
      <div class="extra" v-if="linkData.subItems" :class="caretClass">
        <BIcon icon="caret-left-fill" />
      </div>
    </router-link>
    <div
      ref="subMenu"
      class="sub-items"
      :style="subMenuStyles"
      v-if="linkData.subItems"
    >
      <div v-for="item of linkData.subItems" :key="item.label">
        <router-link :to="item.to" class="menu-item">
          {{ item.label }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue'

export default {
  components: {
    BIcon
  },
  props: {
    linkData: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.$refs.subMenu) {
      this.subMenuHeight = this.$refs.subMenu.scrollHeight
    }
  },
  data() {
    return {
      isOpen: false,
      subMenuHeight: 0
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    handleClick(e) {
      if (this.$props.linkData.subItems) {
        e.preventDefault()
        this.toggleOpen()
      }
    }
  },
  computed: {
    caretClass() {
      return this.isOpen ? 'opened' : ''
    },
    subMenuStyles() {
      return {
        height: this.isOpen ? `${this.subMenuHeight}px` : '0px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-item {
  color: $white;
  padding: 15px 25px;
  transition: 200ms background-color ease-in-out;
  background-color: transparent;
  font-weight: bold;
  color: $white;
  display: flex;
  align-items: center;

  &.router-link-exact-active {
    background-color: $gray;
  }

  &:hover {
    background-color: darken($blue, 10%);
    cursor: pointer;
  }
}

.icon-container {
  .b-icon {
    font-size: 21px;
    margin-right: 25px;
  }
}

.label {
  flex: 1;
}

.sub-items {
  color: $white;
  background: darken($blue, 10%);
  overflow: hidden;
  transition: height 222ms ease-in-out;
}

.sub-item {
  margin-left: 50px;
  font-weight: bold;
  padding: 15px 0 15px 15px;
  background-color: transparent;
  transition: 200ms background-color ease-in-out;

  &.active {
    background-color: darken($blue, 15%);
  }

  &:hover {
    background-color: lighten($blue, 10%);
    cursor: pointer;
  }
}

.extra {
  transition: transform 222ms ease-in-out;

  &.opened {
    transform: rotate(-90deg);
  }
}
</style>
